// extracted by mini-css-extract-plugin
export default {"background":"nK","weightImage":"oK","drinkImage":"pK","content":"qK","rtbLeft":"rK","rtbRight":"sK","rtbLeftMobile":"tK","imageContainer":"uK","rtbBox":"vK","line":"wK","rtbDesktop":"xK"};
    if(module.hot) {
      // 1714442370042
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  